import { ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { EntityListProductInputData } from '../entityListTypes';

export abstract class InputFormatProvider<T extends EntityListProductInputData> {
  abstract getInputFormat(): readonly ImportFormatItem<T>[];
}
